import { render, staticRenderFns } from "./Continents.vue?vue&type=template&id=2e748f6a&scoped=true&"
import script from "./Continents.vue?vue&type=script&lang=js&"
export * from "./Continents.vue?vue&type=script&lang=js&"
import style0 from "./Continents.vue?vue&type=style&index=0&id=2e748f6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e748f6a",
  null
  
)

export default component.exports